import { RootState } from '@/store'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

export function usePermission(permission: string) {
	const permissions = useSelector((state: RootState) => state.user.permissions)
	return useMemo(() => permissions.includes(permission) || !permission, [permissions, permission])
}
